import { SkiCrossCountryIcon } from './SkiCrossCountryIcon';

/**
 * author: Google
 * id BD9C05A6-55EA-4F72-A216-85F990F65EDA
 * name ski-cross-country
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ski-cross-country.svg
 * tags
 * - Sport 
 * - People / Family 
 */
export const NordicWalkingIcon = SkiCrossCountryIcon;
export default NordicWalkingIcon